import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconPlay = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M10.976 4.418c-1.663.176-3.285 1.165-4.169 2.543-.532.83-.796 1.557-.918 2.536-.09.711-.09 44.295 0 45.006.163 1.305.66 2.375 1.536 3.312 1.084 1.159 2.554 1.782 4.191 1.778a5.45 5.45 0 0 0 2.596-.619c1.38-.693 41.023-21.96 41.414-22.217 1.362-.897 2.314-2.489 2.487-4.161.218-2.099-.769-4.222-2.487-5.353-.394-.26-40.099-21.559-41.386-22.201a8 8 0 0 0-.896-.389 6.3 6.3 0 0 0-2.368-.235m.043 4.088A1.8 1.8 0 0 0 9.983 9.52c-.126.338-.127.533-.127 22.48 0 22.098 0 22.14.13 22.487.283.757 1.092 1.222 1.873 1.077.31-.058 3.933-1.976 20.881-11.055 11.279-6.042 20.615-11.064 20.747-11.16s.327-.331.433-.522c.165-.299.192-.413.192-.827 0-.418-.026-.526-.198-.832a1.66 1.66 0 0 0-.544-.587c-.628-.425-41.039-22.028-41.368-22.114-.417-.109-.573-.103-.983.04" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconPlay.displayName = 'IconPlay';